export default __webpack_public_path__ + "static/houseBigImg-4b1a4e9bed5733409f01e9f8fd65df08.png";